import React, { useEffect, useState, useRef } from 'react';
import { Modal, Box, CopyToClipboard, Alert, SpaceBetween, Button, Container, Popover, Header, TextContent, Link, Form, ColumnLayout, StatusIndicator, Spinner, Icon, Grid, Select, Table, Textarea } from '@cloudscape-design/components';
import { ItemContext } from '../context/itemContext';
import { SelectedItemContextType, SelectedItem } from '../@types/item';
import { UserContext } from '../context/userContext';
import { UserInfoContextType, UserInfo } from '../@types/user';
import { fetchAuthSession } from 'aws-amplify/auth';
import EditItemDetailBusinesshecklist from './components/EditItemDetailBusinessChecklist';
import EditItemDetailQualificationChecklist from './components/EditItemDetailQualificationChecklist';
import EditItemDetailSolutionsChecklist from './components/EdititemDetailSolutionsChecklist';
import EditItemDetailWinLoss from './components/EditItemDetailWinLoss';
import { useCollection } from '@cloudscape-design/collection-hooks';
import { getApiUrl } from '../utils/apiConfig';



export default function EditItemDetails(dataTable: any) {

  const LOCALE = 'en';
  const apiUrl = getApiUrl();
  const path = '/getItemDetails';
  const pathUpdate = '/updateItem';
  const pathGetEmployeeByLogin = '/papiEmployeeByLogin';
  const pathGetAuditHistory = '/getAudit';
  let ItemData;

  //Context Information 
  const { user, updateUser } = React.useContext(UserContext) as UserInfoContextType;
  const { item, updateItem } = React.useContext(ItemContext) as SelectedItemContextType;
  const [tableItems, setTableItems] = useState<any[]>([]);
  const [itemDataDetails, setItemData] = useState<any[]>([]);

  //Alert message
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<any>("success");
  const alertMessageRef = useRef<HTMLInputElement>(null);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);

  //Audit History
  const [auditHistoryVisible, setAuditHistoryVisible] = useState(false);
  const [auditHistory, setAuditHistory] = useState<any[]>([]);

  const [salesforceOppyURL, setSalesforceOppyURL] = useState("https://aws-crm.lightning.force.com/lightning/r/Opportunity/[Opportunity ID]");
  const [companyName, setCompanyName] = useState("");
  const [companyIndustry, setCompanyIndustry] = useState("");
  const [regionCountry, setRegionCountry] = useState("");
  const [preQualiChecklist, setPreQualiChecklist] = useState("Incomplete");
  const [postQualificationBusiness, setPostQualificationBusiness] = useState("Incomplete");
  const [postQualificationSolution, setPostQualificationSolution] = useState("Incomplete");
  const [winLossAnalysis, setWinLossAnalysis] = useState("Incomplete");
  const [preQualiChecklistScore, setPreQualiChecklistScore] = useState(0);
  const [qualiChecklistRAG, setQualiChecklistRAG] = useState<any>("red");
  const [postQualificationBusinessScore, setPostQualificationBusinessScore] = useState(0);
  const [postQualificationBusinessRAG, setPostQualificationBusinessRAG] = useState<any>("incomplete");
  const [postQualificationSolutionScore, setPostQualificationSolutionScore] = useState(0);
  const [postQualificationSolutionRAG, setPostQualificationSolutionRAG] = useState<any>("incomplete");
  const [awsAccountExec, setAwsAccountExec] = useState("");
  const [connectSpecialist, setConnectSpecialist] = useState('');
  const [connectSpecialistSA, setConnectSpecialistSA] = useState('');
  const [qualiChecklistRAGVariant, setQualiChecklistRAGVariant] = useState<any>('error');
  const [postQualificationBusinessRAGVariant, setPostQualificationBusinessRAGVariant] = useState<any>('info');
  const [postQualificationSolutionRAGVariant, setPostQualificationSolutionRAGVariant] = useState<any>('info');
  const [qualificationRecommendation, setQualificationRecommendation] = useState('RECOMMENDED ACTION: NO BID OR ENGAGE PARTNER');
  const [businessRecommendation, setBusinessRecommendation] = useState('No Bid!');
  const [solutionRecommendation, setSolutionRecommendation] = useState('No Bid!');
  const [lastEditBy, setLastEditBy] = useState('');
  const [lastEditDate, setLastEditDate] = useState('');
  const [visible, setVisible] = React.useState(true);

  //Upstream data 
  const [upstreamData, setUpstreamData] = useState<any[]>([]);

  //Qualification override data
  interface qualificationStateInterface {
    label?: string;
    value?: string;
    icon?: string;
  }
  const [qualificationState, setQualificationState] = useState<qualificationStateInterface>({ label: "Not-set", value: "Not-set" });

  // * PAPI Data Plane
  const [connectSpecialistPAPI, setConnectSpecialistPAPI] = useState('');
  const [connectSpecialistPAPIbusTitle, setConnectSpecialistPAPIbusTitle] = useState('');
  const [connectSpecialistSAPAPI, setConnectSpecialistSAPAPI] = useState('');
  const [connectSpecialistSAPAPIbusTitle, setConnectSpecialistSAPAPIbusTitle] = useState('');
  const [awsAccountExecPAPI, setAwsAccountExecPAPI] = useState('');
  const [awsAccountExecPAPIbusTitle, setAwsAccountExecPAPIbusTitle] = useState('');

  const getEmployeeByLogin = async (login: string) => {
    try {
      const token = (await fetchAuthSession()).tokens?.idToken?.toString();
      const body = {
        login: login
      };
      const response = await fetch(`${apiUrl}${pathGetEmployeeByLogin}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        console.warn(`Employee API failed with status ${response.status} for login: ${login}`);
        // Return fallback data structure
        return {
          firstName: login || 'Unknown',
          lastName: '',
          businessTitle: 'Employee details unavailable'
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching employee details:', error);
      // Return fallback data structure
      return {
        firstName: login || 'Unknown',
        lastName: '',
        businessTitle: 'Employee details unavailable'
      };
    }
  }

  function formatDate(date: Date): string {
    const dateFormatter = new Intl.DateTimeFormat('en-US', { dateStyle: 'long' });
    const timeFormatter = new Intl.DateTimeFormat('en-US', { timeStyle: 'short', hour12: false });
    return `${dateFormatter.format(date)}, ${timeFormatter.format(date)}`;
  }

  useEffect(() => {
    const getTableItems = async () => {
      const token = (await fetchAuthSession()).tokens?.idToken?.toString();
      const body = {
        id: item.id,
        user: user.username
      };
      const response = await fetch(`${apiUrl}${path}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)

      });
      const data = await response.json();
      console.log(`Item Data from fetch: ${JSON.stringify(data)}`)
      console.log(`Item Data from parent: ${JSON.stringify(dataTable)}`);
      function getVal(id: any) {
        let obj = dataTable.data.filter((object: any) => object.id === id);
        return obj[0];
      }
      const sourceDataItem = getVal(item.id);
      console.log(`Source Item in ItemDetail.tsx: ${JSON.stringify(sourceDataItem)}`);
      setTableItems(data);
      setItemData([sourceDataItem]);
      setSalesforceOppyURL(sourceDataItem.salesforceOppyURL);
      setCompanyName(sourceDataItem.companyName);
      setCompanyIndustry(sourceDataItem.companyIndustry);
      setRegionCountry(sourceDataItem.regionCountry);
      setPostQualificationBusiness(sourceDataItem.postQualificationBusiness);
      setPreQualiChecklist(sourceDataItem.preQualiChecklist);
      setPostQualificationSolution(sourceDataItem.postQualificationSolution);
      setAwsAccountExec(sourceDataItem.awsAccountExec);
      setConnectSpecialist(sourceDataItem.connectSpecialist);
      setConnectSpecialistSA(sourceDataItem.connectSpecialistSA);
      setWinLossAnalysis(sourceDataItem.winLossAnalysis);
      setPreQualiChecklistScore(data.item[0].qualiChecklistScore);
      if (sourceDataItem.updatedBy) setLastEditBy(sourceDataItem.updatedBy);
      if (sourceDataItem.updatedAt) setLastEditDate(formatDate(sourceDataItem.updatedAt));
      try {
        setQualiChecklistRAG(data.item[0].qualiChecklistRAG);
      } catch (error) {
        console.log(`Error setting RAG: ${error}`)
      }
      if (sourceDataItem.qualificationState) {
        setQualificationState(sourceDataItem.qualificationState)
      }

      if (data.item[0].qualiChecklistScore <= 0) {
        setQualiChecklistRAGVariant('error');
        setQualificationRecommendation('NO BID OR ENGAGE PARTNER');
      }
      if (data.item[0].qualiChecklistScore > 0 && data.item[0].qualiChecklistScore <= 70) {
        setQualiChecklistRAGVariant('warning');
        setQualificationRecommendation('NO BID OR PLEASE VERIFY WITH CXE SPECIALIST SELLER');
      }
      if (data.item[0].qualiChecklistScore > 70) {
        setQualiChecklistRAGVariant('success');
        setQualificationRecommendation('PLEASE PROCEED TO BUSINESS VALIDATION')
      }
      if (sourceDataItem.postQualificationBusiness === 'Completed') {
        setPostQualificationBusinessScore(data.item[0].businessChecklistScore);
        setPostQualificationBusinessRAG(data.item[0].businessChecklistRAG);
        if (data.item[0].businessChecklistScore <= 0) {
          setPostQualificationBusinessRAGVariant('error');
          setBusinessRecommendation('No Bid!')

        }
        if (data.item[0].businessChecklistScore > 0 && data.item[0].businessChecklistScore <= 80) {
          setPostQualificationBusinessRAGVariant('warning');
          setBusinessRecommendation('MORE INFO/ DEEPER ENGAGEMENT NEEDED WITH CUSTOMER TO ADDRESSS THE RED FLAGS')
        }
        if (data.item[0].businessChecklistScore > 80) {
          setPostQualificationBusinessRAGVariant('success');
          setBusinessRecommendation('OPPORTUNITY IS A GOOD BUSINESS FIT. PLEASE PROCEED TO SOLUTION ASSESSMENT')
        }
      }

      if (sourceDataItem.postQualificationSolution === 'Completed') {
        setPostQualificationSolutionScore(data.item[0].solutionsChecklistScore);
        setPostQualificationSolutionRAG(data.item[0].solutionshecklistRAG);

        if (data.item[0].solutionsChecklistScore <= 0) {
          setPostQualificationSolutionRAGVariant('error');
          setSolutionRecommendation('No Bid!')

        }
        if (data.item[0].solutionsChecklistScore > 0 && data.item[0].solutionsChecklistScore <= 25) {
          setPostQualificationSolutionRAGVariant('warning');
          setSolutionRecommendation('MORE INFO/ DEEPER ENGAGEMENT NEEDED WITH CUSTOMER TO ADDRESSS THE RED FLAGS')
        }
        if (data.item[0].solutionsChecklistScore > 25) {
          setPostQualificationSolutionRAGVariant('success');
          setSolutionRecommendation('OPPORTUNITY IS A GOOD SOLUTION  FIT')
        }
      }

      return { data, sourceDataItem };
    }

    getTableItems();


  }, [item.visible, item.id, ItemData])

  useEffect(() => {
    if (alertVisible) {
      alertMessageRef.current?.focus();
    }
  }, [alertVisible])

  const handleUpdateFromPreQualification = (data: any) => {
    console.log(`Update from preQual: ${JSON.stringify(data)}`);
    const merged = {
      ...upstreamData,
      ...data
    }
    console.log(`Merged: ${JSON.stringify(merged)}`);
    setUpstreamData(merged);
  }

  const handleUpdateFromBusinessChecklist = (data: any) => {
    console.log(`Update from Business: ${JSON.stringify(data)}`);
    const merged = {
      ...upstreamData,
      ...data
    }
    setUpstreamData(merged);
  }

  const handleUpdateFromSolutionsChecklist = (data: any) => {
    console.log(`Update from Solutions: ${JSON.stringify(data)}`);
    const merged = {
      ...upstreamData,
      ...data
    }
    setUpstreamData(merged);
  }

  const handleUpdateFroWinLoss = (data: any) => {
    console.log(`Update from WinLoss: ${JSON.stringify(data)}`);
    const merged = {
      ...upstreamData,
      ...data
    }
    setUpstreamData(merged);
  }

  const getAuditHistory = async (id: string) => {
    const token = (await fetchAuthSession()).tokens?.idToken?.toString();
    const body = {
      id: id,
      user: user.username
    };
    fetch(`${apiUrl}${pathGetAuditHistory}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(body)

    })
      .then(response => response.json())
      .then(data => {
        console.log(`Audit History: ${JSON.stringify(data)}`);
        setAuditHistory(data.item);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  const { items, actions, filteredItemsCount, collectionProps, filterProps, paginationProps } = useCollection(
    auditHistory,
    {
    })

  useEffect(() => {
    const fetchDetails = async () => {
      const employeeDetails = await getEmployeeByLogin(connectSpecialist);
      console.log(`Employee Details: ${JSON.stringify(employeeDetails)}`);
      setConnectSpecialistPAPI(`${employeeDetails.firstName} ${employeeDetails.lastName}`)
      setConnectSpecialistPAPIbusTitle(employeeDetails.businessTitle)
    }
    if (connectSpecialist !== '') {
      console.log(`Try to find Employee details by login`);
      fetchDetails();
    } else {
      console.log(`No Connect Specialist set`);
      setConnectSpecialistPAPI(connectSpecialist);
    }

  }, [connectSpecialist])

  useEffect(() => {
    const fetchDetails = async () => {
      const employeeDetails = await getEmployeeByLogin(connectSpecialistSA);
      console.log(`Employee Details: ${JSON.stringify(employeeDetails)}`);
      setConnectSpecialistSAPAPI(`${employeeDetails.firstName} ${employeeDetails.lastName}`)
      setConnectSpecialistSAPAPIbusTitle(employeeDetails.businessTitle)
    }
    if (connectSpecialist !== '') {
      console.log(`Try to find Employee details by login`);
      fetchDetails();
    } else {
      console.log(`No Connect Specialist set`);
      setConnectSpecialistSAPAPI(connectSpecialist);
    }
  }, [connectSpecialistSA])

  useEffect(() => {
    const fetchDetails = async () => {
      const employeeDetails = await getEmployeeByLogin(awsAccountExec);
      console.log(`Employee Details: ${JSON.stringify(employeeDetails)}`);
      setAwsAccountExecPAPI(`${employeeDetails.firstName} ${employeeDetails.lastName}`)
      setAwsAccountExecPAPIbusTitle(employeeDetails.businessTitle)
    }
    if (connectSpecialist !== '') {
      console.log(`Try to find Employee details by login`);
      fetchDetails();
    } else {
      console.log(`No Connect Specialist set`);
      setAwsAccountExecPAPI(awsAccountExec);
    }
  }, [awsAccountExec])

  const content = (
    <>
      <Modal
        onDismiss={() => {
          setVisible(false)
          updateItem({ id: item.id, owner: item.owner, visible: false, soutionsFitVisible: false, businessFitVisible: false, editBusinessFitVisible: false })
        }
        }
        visible={visible}
        size='max'
        header={item.id}
      >
        <Modal visible={auditHistoryVisible} onDismiss={() => { setAuditHistoryVisible(false) }} size='max'>
          <Table
            renderAriaLive={({
              firstIndex,
              lastIndex,
              totalItemsCount
            }) => `Displaying ${firstIndex} to ${lastIndex} of ${totalItemsCount} items`}
            columnDefinitions={[
              {
                header: 'Updated By',
                cell: item => String(item.updatedBy)
              },
              {
                header: 'Updated At',
                cell: item => (String(formatDate(item.updatedAt)))
              },
              {
                header: 'Element',
                cell: item => (
                  <Textarea
                  value={JSON.stringify(item)} />
                )
              }
            ]}
            items={auditHistory}
          />
        </Modal>

        {alertVisible === true && (
          <Alert
            ref={alertMessageRef}
            type={alertType}
            statusIconAriaLabel={alertType}
            dismissible
            onDismiss={() => {
              if (alertType === 'success') {
                updateItem({ id: item.id, owner: item.owner, visible: false, soutionsFitVisible: false, businessFitVisible: false, editBusinessFitVisible: false });
                setAlertVisible(false);
              }
              else {
                setAlertVisible(false);
              }

            }

            }
          >{alertMessage} </Alert>
        )}
        <Container
          header={
            <Grid gridDefinition={[{ colspan: 10 }, { colspan: 2 }]}>
              <Header
                variant="awsui-h1-sticky"
              >
                <Link external href={`${salesforceOppyURL}/view`}>Link to {companyName} Salesforce Opportunity</Link>
                <TextContent><small>Last updated by {lastEditBy} at {lastEditDate} </small></TextContent>
              </Header>
              <div>
                <CopyToClipboard copyButtonText='Copy' copyErrorText='Error copy to clipboard' copySuccessText='RFx Record link copied' textToCopy={`${window.location.origin}/AllItems/${item.id}/edit`} />
                <Button iconName='key' onClick={() => {
                  setAuditHistoryVisible(true)
                  getAuditHistory(String(item.id))
                }}> History</Button>
              </div>
            </Grid>
          }
        >
          <form onSubmit={e => e.preventDefault()}>
            <Form
              actions={
                <SpaceBetween direction="horizontal" size="s">
                  <Button formAction="none" variant="link" onClick={() => {
                    updateItem({ id: item.id, owner: item.owner, visible: false, soutionsFitVisible: false, businessFitVisible: false, editBusinessFitVisible: false })
                  }}>
                    Cancel
                  </Button>
                  {showSubmitButton === true && (
                    <Button variant="primary" onClick={async (e) => {


                      setSubmitButtonDisabled(true);
                      console.log(`Upstream Data: ${JSON.stringify(upstreamData)}`);
                      const object = {
                        ...upstreamData, ...{
                          id: item.id,
                          owner: item.owner,
                          updatedBy: user.username,
                          qualificationState: qualificationState

                        }
                      };
                      console.log(`Object: ${JSON.stringify(object)}`);
                      const token = (await fetchAuthSession()).tokens?.idToken?.toString();
                      try {
                        const response = await fetch(apiUrl + pathUpdate, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                          },
                          body: JSON.stringify(object)
                        });
                        const body = await response.json();
                        console.log(JSON.stringify(body));
                        if (response.status === 200) {
                          setAlertMessage("Item successfully updated");
                          setAlertType("success");
                          setAlertVisible(true);
                          setSubmitButtonDisabled(false);
                          setShowSubmitButton(false);
                          setShowCloseButton(true);

                          setTimeout(() => {
                            updateItem({ id: item.id, owner: item.owner, visible: false, soutionsFitVisible: false, businessFitVisible: false, editBusinessFitVisible: false });
                            window.location.reload();
                          }, 5000);

                        } else {
                          setAlertMessage(`${body}`);
                          setAlertType("error");
                          setAlertVisible(true);
                          setSubmitButtonDisabled(false);
                        }
                      } catch (error) {
                        console.log(`Error on fetch ${JSON.stringify(error)}`);
                        setAlertMessage(`Error updating Item:  ${error}`);
                        setAlertType("error");
                        setAlertVisible(true);
                        setSubmitButtonDisabled(false);
                      }




                    }}>{submitButtonDisabled === true && (<Spinner />)}Submit</Button>
                  )}

                  {showCloseButton === true && (
                    <Button formAction='none' variant='primary' onClick={() => {
                      updateItem({ id: item.id, owner: item.owner, visible: false, soutionsFitVisible: false, businessFitVisible: false, editBusinessFitVisible: false })
                    }}>Close</Button>
                  )}

                </SpaceBetween>
              }>
              <SpaceBetween size="s" direction='vertical'>
                <ColumnLayout columns={4} variant="text-grid">
                  <SpaceBetween size="l">
                    <div>
                      <Box variant="awsui-key-label">Customer Name</Box>
                      <div>{companyName}</div>
                    </div>
                    <div>
                      <Box variant="awsui-key-label">Industry</Box>
                      <div>{companyIndustry}</div>
                    </div>
                    <div>
                      <Box variant="awsui-key-label">Region</Box>
                      <div>{regionCountry}</div>
                    </div>
                  </SpaceBetween>

                  <SpaceBetween size="l">
                    <div>
                      <Box variant="awsui-key-label">Pre-Qualification Checklist</Box>
                      <div><StatusIndicator type={preQualiChecklist === 'Completed' ? 'success' : 'info'}>{preQualiChecklist}</StatusIndicator></div>
                    </div>
                    <div>
                      <Box variant="awsui-key-label">Post-Qualification Business fit</Box>
                      <div><StatusIndicator type={postQualificationBusiness === 'Completed' ? 'success' : 'info'}>{postQualificationBusiness}</StatusIndicator></div>
                    </div>
                    <div>
                      <Box variant="awsui-key-label">Post-Qualification Solutions fit</Box>
                      <div><StatusIndicator type={postQualificationSolution === 'Completed' ? 'success' : 'info'}>{postQualificationSolution}</StatusIndicator></div>
                    </div>
                  </SpaceBetween>

                  <SpaceBetween size="l">
                    <div>
                      <Box variant="awsui-key-label">Pre-Qualification RAG Status</Box>
                      <StatusIndicator
                        type={qualiChecklistRAGVariant}>{qualiChecklistRAG.charAt(0).toUpperCase() + qualiChecklistRAG.slice(1)}</StatusIndicator>
                    </div>
                    <div>
                      <Box variant="awsui-key-label">Post-Qualification Business RAG Status</Box>
                      <StatusIndicator
                        type={postQualificationBusinessRAGVariant}>{postQualificationBusinessRAG.charAt(0).toUpperCase() + postQualificationBusinessRAG.slice(1)}</StatusIndicator>
                    </div>
                    <div>
                      <Box variant="awsui-key-label">Post-Qualification Solutions RAG Status</Box>
                      <StatusIndicator
                        type={postQualificationSolutionRAGVariant}>{postQualificationSolutionRAG.charAt(0).toUpperCase() + postQualificationSolutionRAG.slice(1)}</StatusIndicator>
                    </div>
                  </SpaceBetween>

                  <SpaceBetween size="l">
                    <div>
                      <Box variant="awsui-key-label">AWS Account Executive</Box>
                      <Link
                        variant='info'
                        href={`https://phonetool.amazon.com/users/${awsAccountExec}`}>{awsAccountExecPAPI}</Link><br />
                      <small style={{ color: 'gray' }}>{awsAccountExecPAPIbusTitle}</small>
                    </div>
                    <div>
                      <Box variant="awsui-key-label">AWS Connect Specialist</Box>
                      <Link
                        variant='info'
                        href={`https://phonetool.amazon.com/users/${connectSpecialist}`}>{connectSpecialistPAPI}</Link><br />
                      <small style={{ color: 'gray' }}>{connectSpecialistPAPIbusTitle}</small>

                    </div>
                    <div>
                      <Box variant="awsui-key-label">AWS Connect Specialist SA</Box>
                      <Link
                        variant='info'
                        href={`https://phonetool.amazon.com/users/${connectSpecialistSA}`}>{connectSpecialistSAPAPI}</Link><br />
                      <small style={{ color: 'gray' }}>{connectSpecialistSAPAPIbusTitle}</small>
                    </div>

                  </SpaceBetween>
                </ColumnLayout>
                <ColumnLayout columns={4} variant='text-grid'>
                  <SpaceBetween size="l">
                    <div>
                      <Box variant="awsui-key-label">Qualification Recommendation</Box>
                      {qualificationRecommendation}


                    </div>
                  </SpaceBetween>
                  <SpaceBetween size="l">
                    <div>
                      <Box variant="awsui-key-label">Business Recommendation</Box>
                      <div>{businessRecommendation}</div>
                    </div>
                  </SpaceBetween>
                  <SpaceBetween size="l">
                    <div>
                      <Box variant="awsui-key-label">Solutions Recommendation</Box>
                      <div>{solutionRecommendation}</div>
                    </div>
                  </SpaceBetween>
                  <SpaceBetween size="l">
                    <div>
                      <Box variant="awsui-key-label" >Qualification Status <Popover dismissButton={true}
                        header="Bid / no-Bid decision" content={<small>Indicate if you decide to proceed participating to this tender.</small>}><small>Info</small></Popover></Box>

                      <div>
                        <Select
                          selectedOption={qualificationState}
                          onChange={({ detail }) => {
                            setQualificationState(detail.selectedOption);
                          }}
                          options={[
                            {
                              label: 'Qualified In - AWS led',
                              value: 'Qualified In - AWS led',
                            },
                            {
                              label: 'Qualified In - Partner led',
                              value: 'Qualified In - Partner led',
                            },
                            {
                              label: 'Qualified In - Disruptive bid',
                              value: 'Qualified In - Disruptive bid',
                            },
                            {
                              label: 'Qualified Out',
                              value: 'Qualified Out'
                            },
                            {
                              label: 'Not-set',
                              value: 'Not-set'
                            },


                          ]} />
                      </div>
                    </div>
                  </SpaceBetween>
                </ColumnLayout>
                {preQualiChecklist === 'Completed' && (
                  <EditItemDetailQualificationChecklist data={tableItems} sourceData={itemDataDetails} sendDataToParent={handleUpdateFromPreQualification}></EditItemDetailQualificationChecklist>
                )}

                {postQualificationBusiness === 'Completed' && (
                  <EditItemDetailBusinesshecklist data={tableItems} sourceData={itemDataDetails} sendDataToParent={handleUpdateFromBusinessChecklist}></EditItemDetailBusinesshecklist>
                )}
                {postQualificationSolution === 'Completed' && (
                  <EditItemDetailSolutionsChecklist data={tableItems} sourceData={itemDataDetails} sendDataToParent={handleUpdateFromSolutionsChecklist}></EditItemDetailSolutionsChecklist>
                )}
                <EditItemDetailWinLoss data={tableItems} sourceData={itemDataDetails} sendDataToParent={handleUpdateFroWinLoss}></EditItemDetailWinLoss>

              </SpaceBetween>
            </Form>
          </form>
        </Container>


      </Modal>
    </>
  )

  return content
}